export const ACTIVITY_SURVEY_LISTING =
  '/activity_feed/survey/:survey_id/listing/:listing_id/';
export const ACTIVITY_SURVEY_BUILDING =
  '/activity_feed/survey/:survey_id/building/:building_id/';
export const ACTIVITY_LISTING = '/activity_feed/listing/:listing_id/';
export const ACTIVITY_SURVEY = '/activity_feed/survey/:survey_id/';
